/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Tally1 = [["path", { d: "M4 4v16" }]];

export { Tally1 as default };
//# sourceMappingURL=tally-1.js.map
